import React, { useMemo } from 'react';
import { TabsProvider } from './tabs.provider';
import { ITabs, ITabsProps } from './tabs.types';
import { TabItem, TabItems } from './tab-items';
import { TabContent } from './tab-content';

export const Tabs: ITabs<ITabsProps> = ({ selectedTabId, handleSelectTab, children }) => {

    const contextValue = useMemo(() => ({
        selectedTabId,
        handleSelectTab,
    }), [selectedTabId, handleSelectTab]);

    return (
        <TabsProvider.Provider value={contextValue}>
            {children}
        </TabsProvider.Provider>
    );
};

Tabs.TabItems = TabItems;
Tabs.TabItem = TabItem;
Tabs.Content = TabContent;
